/** Service Type and Charges */
export const ACTIVATION = "ACTIVATION";
export const RENEWAL = "RENEWAL";
